import React, { useEffect, useRef, useState } from "react";
import "../HolidayLists/HolidayList.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../assets/images/npw-logo.png";
import axios from "../../utils/axiosConfig";

const API = "/api/holidaylist";

const HolidayList = () => {
  const pdfRef = useRef();

  const [holidays, setHolidays] = useState([]);
  const [vacations, setVacations] = useState([]);
  const [header, setHeader] = useState("");

  // ❌ REMOVE THIS LINE (WRONG POSITION)
  // setHeader(res.data.header || "");

  // ================= FETCH =================
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(API);

      setHolidays(res.data.holidays || []);
      setVacations(res.data.vacations || []);
      setHeader(res.data.header || ""); // ✅ FIXED HERE
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  // ================= GROUP =================
  const grouped = holidays.reduce((acc, item) => {
    const month = item.months || "Others";
    if (!acc[month]) acc[month] = [];
    acc[month].push(item);
    return acc;
  }, {});

  // ================= SUPERSCRIPT =================
  const formatDateWithSuperscript = (text) => {
    if (!text) return "";
    return text.replace(
      /(\d+)(st|nd|rd|th)/g,
      function (_, num, suffix) {
        return num + "<sup>" + suffix + "</sup>";
      }
    );
  };

  // ================= VACATION SAFE =================
  const getVacation = (type) => {
    const found = vacations.find((v) => v.type === type);
    return found ? found.description : "";
  };

  // ================= PDF =================
  const handleDownloadPDF = async () => {
    const input = pdfRef.current;

    const canvas = await html2canvas(input, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = 210;
    const pageHeight = 297;

    const margin = 8;
    const headerHeight = 30;
    const footerHeight = 10;

    const usableHeight = pageHeight - headerHeight - footerHeight;
    const imgWidth = pageWidth - margin * 2;

    const totalHeightPx = canvas.height;
    const pageHeightPx = (usableHeight * canvas.width) / imgWidth;

    let currentY = 0;

    const addHeader = () => {
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.text("NORTH POINT CHILDREN'S ACADEMY", pageWidth / 2, 12, {
        align: "center",
      });

      pdf.setFontSize(9);
      pdf.text(
        "50, Tapkeshwar Road, Garhi Cantt, Dehradun, Uttarakhand - 248003",
        pageWidth / 2,
        17,
        { align: "center" }
      );

      pdf.text(
        "Ph: +91-0135-3598009, +91-9837923036, +91-8273065299  |  www.northpointdoon.in",
        pageWidth / 2,
        22,
        { align: "center" }
      );

      pdf.addImage(logo, "PNG", 10, 8, 18, 18);
    };

    const addFooter = () => {
      pdf.setFontSize(9);
      pdf.text(
        "North Point Children's Academy  |  www.northpointdoon.in",
        pageWidth / 2,
        pageHeight - 5,
        { align: "center" }
      );
    };

    while (currentY < totalHeightPx) {
      const pageCanvas = document.createElement("canvas");
      const ctx = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = Math.min(pageHeightPx, totalHeightPx - currentY);

      ctx.drawImage(
        canvas,
        0,
        currentY,
        canvas.width,
        pageCanvas.height,
        0,
        0,
        canvas.width,
        pageCanvas.height
      );

      const imgData = pageCanvas.toDataURL("image/jpeg", 1.0);

      if (currentY > 0) pdf.addPage();

      addHeader();

      const imgHeight = (pageCanvas.height * imgWidth) / canvas.width;

      pdf.addImage(
        imgData,
        "JPEG",
        margin,
        headerHeight,
        imgWidth,
        imgHeight
      );

      addFooter();

      currentY += pageHeightPx;
    }

    pdf.save("Holiday_List.pdf");
  };

  return (
    <div className="holiday-container">
      <div ref={pdfRef}>
        <div className="holiday-header">
          <h2>{header}</h2>
          <p className="holiday-slogan">
            "Celebrating every occasion with joy, unity & tradition"
          </p>
        </div>

        <div className="pdf-btn-wrap">
          <button onClick={handleDownloadPDF}>Download PDF</button>
        </div>

        {Object.keys(grouped).map((month, index) => (
          <div key={index} className="month-section">
            <h3 className="month-title">{month}</h3>

            <div className="holiday-grid">
              {grouped[month].map((item) => (
                <div key={item.event_id} className="holiday-card">
                  <div className="holiday-date">
                    <span className="day">
                      {item.start_date
                        ? item.start_date.split("-")[0]
                        : ""}
                    </span>
                    <span className="month">{item.months}</span>
                  </div>

                  <div className="holiday-details">
                    <h4>{item.title}</h4>
                    <p className="holiday-day">{item.day}</p>

                    <p
                      className="holiday-full-date"
                      dangerouslySetInnerHTML={{
                        __html: formatDateWithSuperscript(item.hdate),
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="vacation-section">
          <div
            className="vacation-card"
            dangerouslySetInnerHTML={{
              __html: formatDateWithSuperscript(getVacation("Summer")),
            }}
          />
          <div
            className="vacation-card winter"
            dangerouslySetInnerHTML={{
              __html: formatDateWithSuperscript(getVacation("Winter")),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HolidayList;